import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Sits at the foot of the scrolling settings panel while there is something to
 * save. One bar for the whole form, so there is never a question about which
 * Save button covers which field.
 */
export function UnsavedChangesBar({
  summary,
  saving,
  onSave,
  onDiscard,
}: {
  /** What changed, e.g. "kitchen mode and ticket timing". */
  summary: string
  saving: boolean
  onSave: () => void
  onDiscard: () => void
}) {
  return (
    <div className="sticky bottom-0 z-20 pt-2">
      <div
        role="region"
        aria-label="Unsaved changes"
        className="flex flex-col gap-3 rounded-lg border border-border bg-popover px-4 py-3 text-popover-foreground shadow-lg sm:flex-row sm:items-center sm:justify-between"
      >
        <p className="text-sm">
          <span className="font-medium">Not saved yet.</span>{' '}
          <span className="text-muted-foreground">You changed {summary}.</span>
        </p>
        <div className="flex shrink-0 gap-2">
          <Button type="button" variant="ghost" onClick={onDiscard} disabled={saving}>
            Discard
          </Button>
          <Button type="button" onClick={onSave} disabled={saving}>
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Save changes
          </Button>
        </div>
      </div>
    </div>
  )
}
